
import { createAction } from '@reduxjs/toolkit'

export const triggerImmediateFlagsLoad = createAction("TRIGGER_IMMEDIATE_FLAGS_LOAD_SAGA")
export const triggerEventualFlagsLoad = createAction("TRIGGER_EVENTUAL_FLAGS_LOAD_SAGA ")
export const triggerImmediateIndicatorsLoad = createAction("TRIGGER_IMMEDIATE_INDICATORS_LOAD_SAGA")
export const triggerEventualIndicatorsLoad = createAction("TRIGGER_EVENTUAL_INDICATORS_LOAD_SAGA")
